'use client';

import { useSalePageQuery } from '@/entities/salePage';
import { qaAttr, qaId } from '@/lib/qa';
import { Column, Element } from '@vuddy/components';
import { notFound } from 'next/navigation';
import { ChannelInfoSection } from '../../components/channel';
import { SalePageTabLinks } from '../../components/tabLinks/TabLinks';
import { GACHA_STOCK_TAB_LINKS } from '../constants';
import {
  GachaBackgroundSection,
  GachaButtonGroup,
  GachaContentSection,
  GachaTitleSection,
} from './gacha';
import * as styles from './gachaPageView.css';
import { SalePageNavigationBar } from './sale/NavigationBar';
import { SaleTrackEnterEvent } from './TrackEnterEvent';

interface IGachaPageViewProps {
  salePageId: number;
}

export function GachaPageView({ salePageId }: IGachaPageViewProps) {
  const { data: salePage } = useSalePageQuery(salePageId);

  if (!salePage?.gacha?.id) {
    return notFound();
  }

  return (
    <>
      <Column
        {...qaAttr(qaId('sale.gacha', 'page'))}
        backgroundColor="black"
        minHeight="100vh"
        className={styles.root}>
        <SalePageNavigationBar salePageId={salePageId} type="gachaPage" />

        <Column className={styles.gachaContentWrapper}>
          <Element className={styles.gachaBackgroundWrapper}>
            <GachaBackgroundSection salePage={salePage} />
            <Element width="100%" height={160} className={styles.upperDim} />
            <Element width="100%" height={300} className={styles.lowerDim} />
            <GachaTitleSection salePage={salePage} />
          </Element>

          <Column className={styles.channelInfoWrapper}>
            {salePage.channelUrl && (
              <ChannelInfoSection
                channelUrl={salePage.channelUrl}
                salePageId={salePage.id}
                salePageType={salePage.type}
                isGacha
              />
            )}
          </Column>
          <SalePageTabLinks
            tabLinks={GACHA_STOCK_TAB_LINKS}
            backgroundColor="black"
            activeColor="whitePrimary"
            activeBorderColor="whitePrimary"
            inActiveBorderColor="whiteDivider"
            inActiveTextColor="whiteDisabled"
            activeSectionAnchor="top"
          />
          <GachaContentSection salePage={salePage} />

          <GachaButtonGroup
            qaId={qaId('sale.gacha', 'ticket-area')}
            salePage={salePage}
          />
        </Column>
      </Column>
      <SaleTrackEnterEvent salePageId={salePageId} />
    </>
  );
}
